export type PixelStandardEvent = 'ViewContent' | 'SubmitApplication' | 'CompleteRegistration' | 'PageView'
export type GtagStandardEvent = 'view_item' | 'sign_up' | 'conversion'

// Tracking analytic events here
/** ----- Facebook pixel track ----- */
export const fbpTrack = async (eventName: PixelStandardEvent, data?: any) => {
  const pixel = await getImportedScript(isFbpInit)
  if (pixel) {
    console.log('Fbp is ready', eventName, data)
    data ? pixel('track', eventName, data) : pixel('track', eventName)
  }
}

// export const fbpTrackSingle = async (eventName: PixelStandardEvent, ids: string[], eventID?: string) => {
//   if (ids && ids.length > 0) {
//     const pixel = await getImportedScript(isFbpInit)
//     if (pixel) {
//       console.log('Fbp is ready', eventName, ids, Date.now())
//       ids.forEach((id) => {
//         // pixel('addPixelId', id)
//         id &&
//           pixel('trackSingle', id, eventName, { ...{ content_type: 'product', currency: 'USD' }, ...data }, { eventID })
//       })
//     }
//   }
// }

export const isFbpInit = () => {
  //@ts-ignore
  return window.fbq
}
export const isttqInit = () => {
  //@ts-ignore
  return window.ttq
}
/** ----- END Facebook pixel track ----- */

// /** ----- Tiktok pixel track ----- */
// export const ttqTrack = async (eventName: TiktokPixelStandardEvent, data: TiktokPixelEventData) => {
//   const tiktokPixel = await getImportedScript(isTiktokInit)
//   if (tiktokPixel) {
//     console.log('Tiktok pixel is ready', eventName, Date.now())
//     tiktokPixel.track(eventName, { ...{ content_type: 'product', currency: 'USD' }, ...data })
//   }
// }

// export const ttqTrackSingle = async (
//   eventName: TiktokPixelStandardEvent,
//   data: TiktokPixelEventData,
//   ids: string[]
// ) => {
//   if (ids && ids.length > 0) {
//     const tiktokPixel = await getImportedScript(isTiktokInit)
//     if (tiktokPixel) {
//       console.log('Tiktok pixel is ready', eventName, ids, Date.now())
//       ids.forEach((id) => {
//         // tiktokPixel.load(id)
//         id && tiktokPixel.instance(id).track(eventName, { ...{ content_type: 'product', currency: 'USD' }, ...data })
//       })
//     }
//   }
// }

// const isTiktokInit = () => {
//   //@ts-ignore
//   return window.ttq
// }
// /** ----- END Tiktok pixel track ----- */

// /** ----- GA track ----- */
// export const gaSet = async (eventName: string, data: string) => {
//   const ga = await getImportedScript(isGaInit)
//   if (ga) {
//     console.log('Ga is ready', eventName, Date.now())
//     ga('set', eventName, data)
//   }
// }

// export const gaSend = async (eventName: string) => {
//   const ga = await getImportedScript(isGaInit)
//   if (ga) {
//     console.log('Ga is ready', eventName, Date.now())
//     ga('send', eventName)
//   }
// }

// const isGaInit = () => {
//   //@ts-ignore
//   return window.ga
// }
// /** ----- END GA track ----- */

/** ----- Gtag track ----- */
export const gtagPageTracking = async (gaIds: string[], pagePath: string) => {
  const gtag = await getImportedScript(isGtagInit)
  gaIds = [...gaIds]
  if (gtag && gaIds.length > 0) {
    console.log('Gtag is ready', gaIds, pagePath, Date.now())
    gaIds.forEach((gaId) => {
      gtag('config', gaId, { page_path: pagePath })
    })
  }
}

export const gtagTrack = async (eventName: GtagStandardEvent, data?: any) => {
  const gtag = await getImportedScript(isGtagInit)
  if (gtag) {
    console.log('Gtag is ready', eventName, Date.now())
    data ? gtag('event', eventName, data) : gtag('event', eventName)
  }
}

const isGtagInit = () => {
  //@ts-ignore
  return window.gtag
}
/** ----- ENDGtag track ----- */

export const getImportedScript = (checkFn: () => any, timeout = 30000, offset = 300): Promise<any> => {
  let time = 0
  const timer = (ms: number) => new Promise((res) => setTimeout(res, ms))

  const checkExist = async (res: any) => {
    const obj = checkFn()
    if (obj) return res(obj) // ready !!!
    if (time > timeout) return res(null) // timeout !!!
    await timer(offset)
    time += offset
    checkExist(res)
  }

  return new Promise((res) => checkExist(res))
}

export const ispintrkInit = () => {
  //@ts-ignore
  return window.pintrk
}
